var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWritingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.518,
    height: 24.169,
    viewBox: "1682.219 501.255 26.518 24.169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1705.801 505.486 2.635 2.132a.814.814 0 0 1 .12 1.142l-1.178 1.457-3.897-3.151 1.18-1.459a.818.818 0 0 1 1.142-.12Zm-21.534-4.231h16.448a2.057 2.057 0 0 1 2.048 2.048v1.214l-.967 1.194c-.1.123-.185.257-.255.4a2.191 2.191 0 0 0-.153.133v-2.941a.678.678 0 0 0-.673-.676h-16.448a.678.678 0 0 0-.676.676v20.082a.682.682 0 0 0 .676.675h16.448a.673.673 0 0 0 .673-.675v-3.097l.412-.175c.368-.136.692-.37.937-.675l.026-.03v3.977a2.059 2.059 0 0 1-2.048 2.039h-16.448a2.052 2.052 0 0 1-2.048-2.04v-20.081a2.057 2.057 0 0 1 2.048-2.048Zm16.78 16.832-2.767 1.18c-2.017.749-1.927 1.172-1.726-.83l.606-3.5 5.732-7.122 3.884 3.15-5.725 7.122Zm-3.224-2.614 2.56 2.07-1.818.777c-1.424.61-1.385.913-1.137-.546l.395-2.3Z",
    fill: "#707070",
    fillRule: "evenodd",
    "data-name": "writing-icon"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritingIcon);
export default __webpack_public_path__ + "static/media/WritingIcon.7c632317df53321e1e524674df950d3a.svg";
export { ForwardRef as ReactComponent };